// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
// Actions
// CRUD
import {QueryParamsModel} from '../../_base/crud';
import {ProductGroupActions, ProductGroupActionTypes} from '../_actions/product-group.actions';
import {ProductGroupModel} from '../_models/product-group.model';

// Models

export interface ProductGroupsState extends EntityState<ProductGroupModel> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastQuery: QueryParamsModel;
	lastCreatedProductGroupId: number;
	showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<ProductGroupModel> = createEntityAdapter<ProductGroupModel>();

export const initialProductGroupsState: ProductGroupsState = adapter.getInitialState({
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastQuery: new QueryParamsModel({}),
	lastCreatedProductGroupId: undefined,
	showInitWaitingMessage: true
});

export function productGroupsReducer(state = initialProductGroupsState, action: ProductGroupActions): ProductGroupsState {
	switch (action.type) {
		case ProductGroupActionTypes.ProductGroupsPageToggleLoading:
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedProductGroupId: undefined
			};
		case ProductGroupActionTypes.ProductGroupsActionToggleLoading:
			return {
				...state, actionsloading: action.payload.isLoading
			};
		case ProductGroupActionTypes.ProductGroupOnServerCreated:
			return {
				...state
			};
		case ProductGroupActionTypes.ProductGroupCreated:
			return adapter.addOne(action.payload.productGroup, {
				...state, lastCreatedProductGroupId: action.payload.productGroup.id
			});
		case ProductGroupActionTypes.ProductGroupUpdated:
			return adapter.updateOne(action.payload.partialProductGroup, state);
		case ProductGroupActionTypes.ProductGroupsStatusUpdated: {
			const _partialProductGroups: Update<ProductGroupModel>[] = [];
			for (let i = 0; i < action.payload.productGroups.length; i++) {
				_partialProductGroups.push({
					id: action.payload.productGroups[i].id,
					changes: {
						status: action.payload.status
					}
				});
			}
			return adapter.updateMany(_partialProductGroups, state);
		}
		case ProductGroupActionTypes.OneProductGroupDeleted:
			return adapter.removeOne(action.payload.id, state);
		case ProductGroupActionTypes.ManyProductGroupsDeleted:
			return adapter.removeMany(action.payload.ids, state);
		case ProductGroupActionTypes.ProductGroupsPageCancelled:
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		case ProductGroupActionTypes.ProductGroupsPageLoaded:
			return adapter.addMany(action.payload.productGroups, {
				...initialProductGroupsState,
				totalCount: action.payload.totalCount,
				listLoading: false,
				lastQuery: action.payload.page,
				showInitWaitingMessage: false
			});
		default:
			return state;
	}
}

export const getProductGroupState = createFeatureSelector<ProductGroupModel>('productGroups');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
